import { isString, map } from 'lodash'
import { User } from '../../user'
import { DLDocument } from './document'

interface CreateDLLedgerInput {
  name: string
  signed: boolean
}

interface UpdateDLLedgerInput {
  name: string
}

export class DLLedger {
  id: string

  name: string
  signed: boolean

  documents: DLDocument[]
  documentsCount: number
  
  createdAt: number
  createdBy: User
  updatedAt: number
  updatedBy: User

  constructor(data: any = {}) {
    Object.assign(this, data);

    if(this.documents) {
      this.documents = map(data.documents, d => new DLDocument(d));
    }

    if(this.createdBy) {
      this.createdBy = new User(this.createdBy);
    }

    if(this.updatedBy) {
      this.updatedBy = new User(this.updatedBy);
    }
  }

  get valid():boolean {
    // name
    if(!isString(this.name)) {
      return false;
    }

    let trimmedName = this.name.trim();

    if(trimmedName.length > 50) {
      return false;
    }

    return true;
  }

  toCreateDLLedgerInput(): CreateDLLedgerInput {
    return {
      name: this.name,
      signed: this.signed,
    };
  }

  toUpdateDLLedgerInput(): UpdateDLLedgerInput {
    return {
      name: this.name,
    };
  }
}
